import { DefaultSearch, SearchKeyword } from "../../Model/Content";
import { CheckUser } from "../../Model/Users";
import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import {
  SVGIcons,
  ImgIcons,
  VirsionCheck,
  withRouter,
  getslug
} from "../../Helpers/Common";
import {
  BrowserRouter as Router,
  Routes,
  useParams,
  Route,
  Link,
} from "react-router-dom";
import { userprofile } from "../../Model/Users";
import { Metadata } from "../Metadata/Metadata";
import  Header  from "../common/Header";
import { isMobile } from "react-device-detect";
import { Footerdesk } from "../../components/FooterDesk/Footerdesk";
import { Mobilemenu } from "../Mobile_menu/Mobilemenu";
import { Childlock } from "../Childlock/Childlock";
var ImageData = "";
var SVGIcon = "";
ImgIcons().then((result) => (ImageData = result));
SVGIcons().then((resultData) => (SVGIcon = resultData));

class PageNotFound extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      items: [],
      DataisLoaded: false,
      VirsionCheckData: "",
      VirsionCheckDataloaded: false,
      SearchClick: false,
      userData: false,
      NotificationClick: false,
      showallbays: false
    };
  }
  componentDidMount() {
    let data = {
      seesionID:localStorage.getItem("session_id"),
      userID:localStorage.getItem("userID")
    }

    userprofile(data).then((userDatares) => {
      var parseUserdata = JSON.parse(userDatares.data.message);
      if (userDatares.data.message == "session_expired" || parseUserdata.errorcode == "1008") {
        this.props.navigate("/createaccount");
      } else {
        var userDatares = JSON.parse(userDatares.data.message);
        this.setState({
          userData: userDatares.user_data,
        });
      }
    });

  }
  render(){
    var showmessage = "";
    return(<>
         <>
          <motion.div
            className=""
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1 }}
            key="1"
          >
            <Metadata page="HOME" />

            <div className="dD-none">
              <header>
                <div className="mainNav pmenu">
                  <Link to="/">
                    <div className="docubayBack white">
                      Page Not Found
                    </div>
                  </Link>
                  
                </div>
              </header>
              <main>
                <section className="mb-0">
                  <div className="notification-message watchlist-message">
                    <p><span>Oops !</span> Page Not Found</p>
                  </div>
                </section>

              </main>
             
              <Mobilemenu active="4" />
            </div>

            {/* desktop section */}

            <div className="dD-block">
              
                <section className="mb-0">
                  <div className="watchlistNav1">
                  </div>
                  <div className="watchlist-message">
                    <p><span>Oops !</span><br />
                      Page Not Found</p>
                  </div>
                </section>
             
            </div>
            {this.state.userData != false ? (<Childlock data={this.state.userData} />) : null}
            {/* <Mobilemenu active="4" /> */}
            {!isMobile ? null : <Mobilemenu active="4" />}
          </motion.div>
        </> 

      </>)
  }
}

export default withRouter(PageNotFound)